import { useEffect, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

// redux
import { RootState } from '../redux/store'

// utils
import { changeHTMLAttribute } from '../utils'
import MarketingLayout from './MarketingLayout'

const loading = () => <div />

interface DefaultLayoutProps {
	layout: {
		layoutType: string
		layoutWidth: string
		sideBarTheme: string
		sideBarType: string
	}
	children?: any
}

const DefaultLayout = (props: DefaultLayoutProps) => {

	const layoutTheme = useSelector((state: RootState) => state.Layout.layoutTheme)
	const location = useLocation()

	useEffect(() => {
		changeHTMLAttribute('data-mode', layoutTheme)
	}, [layoutTheme])

	// get the child view which we would like to render
	const children = props['children'] || null
	const isAuthPage = location.pathname.startsWith('/auth/')
	const isStandalonePublicPage = location.pathname === '/access-denied'

	if (isAuthPage || isStandalonePublicPage) {
		return <Suspense fallback={loading()}>{children}</Suspense>
	}

	return (
		<MarketingLayout>
			<Suspense fallback={loading()}>{children}</Suspense>
		</MarketingLayout>
	)
}

export default DefaultLayout
